import "./reminder.css";


export default function AppReminder ({}) {

    return (
        <div className="reminder-continer">
            <div>
                <p> משימות </p>
            </div>

            <div>

            </div>
        </div>
    )
}